import { Field, useField } from 'formik';
import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useState } from 'react';
import { FormGroup, Input, Text } from 'tombac';
import OrganizationPicker from "../../core/components/OrganizationPicker/OrganizationPicker";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UserOrganizationFields = _ref => {
  let {
    id,
    name,
    organizationPickerProps: {
      onOrganizationDetails,
      ...organizationPickerProps
    } = {},
    sapIdFormGroupProps
  } = _ref;
  const [, sapIdMeta, sapIdHelpers] = useField(`${name}.sapId`);
  const [selectedOrganization, setSelectedOrganization] = useState();
  const handleOrganizationDetails = organization => {
    setSelectedOrganization(organization);
    sapIdHelpers.setValue(organization?.sapId ?? '');
    sapIdHelpers.setTouched(false);
    onOrganizationDetails?.(organization);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OrganizationPicker, {
      id: id,
      name: `${name}.id`,
      ...organizationPickerProps,
      onOrganizationDetails: handleOrganizationDetails,
      "data-sentry-element": "OrganizationPicker",
      "data-sentry-source-file": "UserOrganizationFields.tsx",
      "data-sentry-element": "OrganizationPicker"
    }), selectedOrganization && !selectedOrganization.root && /*#__PURE__*/_jsx(RequireAuth, {
      role: UserRole.Admin,
      children: /*#__PURE__*/_jsx(FormGroup, {
        error: sapIdMeta.touched && sapIdMeta.error,
        htmlFor: id && `${id}-sap-id`,
        label: "Organization SAP ID",
        ...sapIdFormGroupProps,
        children: selectedOrganization?.sapId ? /*#__PURE__*/_jsx(Text, {
          $alignItems: "center",
          $boxSizing: "border-box",
          $display: "flex",
          $height: "40u",
          $pt: "0.2em",
          as: "div",
          id: id && `${id}-sap-id`,
          children: selectedOrganization.sapId
        }) : /*#__PURE__*/_jsx(Field, {
          as: Input,
          id: id && `${id}-sap-id`,
          invalid: Boolean(sapIdMeta.touched && sapIdMeta.error),
          name: `${name}.sapId`
        })
      })
    })]
  });
};